export const useShowModel = () => {
  /** TODO 为了减少文件的改动，暂时保留 */
  const getSubModelName = (name?: string | null | undefined) => {
    if ((name || '')?.length > 1) {
      return ` (${name})`
    } else {
      return ''
    }
  }
  return {
    getSubModelName,
  }
}
